<div class="stock-content">
        <div class="main-container">
            <!-- Header -->
            <div id="header" class="red-m-arma-border flexible-content" style="margin-bottom: 0; background: white;">
              <!-- Choix de l'usine -->
              <mat-form-field>
                <mat-label>{{ "Choisir une usine" | translate}}</mat-label>
                  <mat-select (selectionChange)="updateFactory()" [(ngModel)]="mSelectedFactory" name="factorySelect">
                      <mat-option *ngFor="let factory of mfactories" [value]="factory">
                          {{factory.Label}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
              <!-- Filtre de la famille de produit -->
              <!-- TODO : Faire un mix entre select et input ici pour saisir mais ne choisir que des valeurs prédéfinies -->
              <mat-form-field style="min-width: 250px;">
                <mat-label>{{ "Choisir une famille de produit" | translate}}</mat-label>
                <mat-select (selectionChange)="updateFamily()" [(ngModel)]="mSelectedFamily" name="familySelect">
                    <mat-option *ngFor="let family of mProductFamilies" [value]="family">
                      {{family.Label}}
                    </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- Zone de recherche -->
              <mat-form-field style="width: 300px; flex-grow: 0.5;"> <!-- Outline pour que ça soit + visible -->
                <mat-label>{{ "Rechercher" | translate }}</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="mSearchText" (keyup)="applyFilter()" placeholder="{{'Rechercher' | translate}}">
                <button mat-button *ngIf="mSearchText" matSuffix mat-icon-button aria-label="Clear" (click)="mSearchText=''; applyFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <!-- Charge le stock acier -->
              <div class="valign-middle">
                <mat-checkbox [(ngModel)]="HTML_Param.SteelStock"
                              (change)="CheckSteelStock()">
                  {{ 'Stock d\'acier' | translate }}
                </mat-checkbox>
              </div>
              <!-- Refresh button -->
              <button mat-fab class="btnRefresh" (click)="refreshData()">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
            <div id="content">
              <div *ngIf="inProgress" class="content mat-elevation-z8 center-elem-lmargin">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                loading....</div>
                <div class="armarow content mat-elevation-z8 center-elem-lmargin red-m-arma-border cmat-red-table-border">
                  <table
                    mat-table
                    matSort
                    #tableStock
                    class="red-m-arma-border mat-elevation-z8 cmat-add-border cmat-red-table-border center-elem-margin"
                    style="min-width: 91%"
                    [dataSource]="dataSource"
                  >
                    <!-- Code du produit -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.ProductCode">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderProductCode class="cmat-center-btn cmat-remove-lr-padding">{{"Code Produit" | translate}}</th>
                      <td mat-cell *matCellDef="let stock">{{stock.ProductCode}}</td>
                    </ng-container>

                    <!-- Libellé du produit -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.Label">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderLabel class="cmat-center-btn cmat-remove-lr-padding">{{"Label" | translate}}</th>
                      <td mat-cell *matCellDef="let stock">{{stock.ProductName}}</td>
                    </ng-container>

                    <!-- Famille du produit -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.Family">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderFamily class="cmat-center-btn cmat-remove-lr-padding">{{"Famille" | translate}}</th>
                      <td mat-cell *matCellDef="let stock">{{stock.ProductFamilyName}}</td>
                    </ng-container>

                    <!-- Unité du produit -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.Unit">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderUnit class="cmat-center-btn cmat-remove-lr-padding">{{"Unit" | translate}}</th>
                      <td mat-cell *matCellDef="let stock">{{stock.ProductUnit1}}</td>
                    </ng-container>

                    <!-- Stock -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.Stock">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderStock class="cmat-center-btn cmat-remove-lr-padding">{{"Stock courant" | translate}}</th>
                      <td mat-cell class="align-right" *matCellDef="let stock">{{stock.Stock | number:'1.3'}}</td>
                    </ng-container>

                    <!-- Minimum Stock -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.MinStock">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderMinStock class="cmat-center-btn cmat-remove-lr-padding">{{"Stock minimum" | translate}}</th>
                      <td mat-cell class="align-right" *matCellDef="let stock">{{stock.MinStock | number:'1.3'}}</td>
                    </ng-container>

                    <!-- Quantité en commande -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.OrderedQty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderOrderedQty class="cmat-center-btn cmat-remove-lr-padding">{{"Quantité commandée" | translate}}</th>
                      <td mat-cell class="align-right" *matCellDef="let stock">{{stock.OrderedQty | number:'1.3'}}</td>
                    </ng-container>

                    <!-- Quantité nécessaire -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.NeededQty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderNeededQty class="cmat-center-btn cmat-remove-lr-padding">{{"Quantité réservée" | translate}}</th>
                      <td mat-cell class="align-right" *matCellDef="let stock">{{stock.NeededQty | number:'1.3'}}</td>
                    </ng-container>

                    <!-- Quantité finale -->
                    <ng-container [matColumnDef]="HTML_STOCK_COL.ForecastQty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header #colHeaderForecastQty class="cmat-center-btn cmat-remove-lr-padding">{{"Quantité prévisionnelle" | translate}}</th>
                      <td mat-cell class="align-right" *matCellDef="let stock">{{stock.ForecastQty | number:'1.3'}}</td>
                    </ng-container>

                    <tr mat-header-row class="tr-header" style="background-color: rgb(203, 69, 69);" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{rowError: IsStockIncorrect(row)}" class="ana-line"></tr>
                  </table>
                  <mat-paginator #TablePaginator [pageSize]="[100]" showFirstLastButtons class="center-content" style="width: 91%"></mat-paginator>
                </div>
            </div>
        </div>
</div>
